<template>
    <div class="menu">
        <div
            class="menu__option"
            v-for="(anchor, index) in menuAnchors"
            :key="index">
            <router-link v-if="anchor.routeName" :to="{ name: anchor.routeName }">{{ anchor.text }}</router-link>
            <router-link v-else-if="$route.name == 'Home'" to="" v-scroll-to="anchor.section">{{ anchor.text }}</router-link>
            <router-link v-else :to="{ name: 'Home', params: { lang: 'pl', section: anchor.section } }">{{ anchor.text }}</router-link>
        </div>
    </div>
</template>

<style lang="scss" scoped>
@import '@/assets/scss/components/header/header-menu';
</style>

<script>
import { mapGetters } from 'vuex'
import { getterTypes } from '@/store/modules/User/getter-types'
import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo, {
    offset: -150,
})

export default {
    name: 'HeaderMenu',
    computed: {
        userData() {
            return this.GET_USER_DATA();
        },
    },
    data() {
        return {
            menuAnchors: [
                {
                    section: '#abousUs',
                    text: 'Poznaj nas'
                },
                {
                    section: '#ourOffer',
                    text: 'Nasza oferta'
				},
                {
                    section: '#partnership',
					text: 'Współpraca'
				},
                {
                    section: '#contact',
                    text: 'Kontakt'
                },
                {
                    routeName: 'Products',
                    text: 'Produkty',
                },
            ],
        }
    },
    methods: {
        ...mapGetters('UserModule', [
			getterTypes.GET_USER_DATA,
        ]),
    }
}
</script>